import Vue from 'vue';
import PackageEntry from './package-entry';
import './package-style';

import config from '/home/runner/work/beyond-ui/beyond-ui/vant.config';
import PR from '/home/runner/work/beyond-ui/beyond-ui/docs/PR.md';
import Changelog from '/home/runner/work/beyond-ui/beyond-ui/docs/changelog.md';
import Contribution from '/home/runner/work/beyond-ui/beyond-ui/docs/contribution.md';
import Deploy from '/home/runner/work/beyond-ui/beyond-ui/docs/deploy.md';
import Home from '/home/runner/work/beyond-ui/beyond-ui/docs/home.md';
import Quickstart from '/home/runner/work/beyond-ui/beyond-ui/docs/quickstart.md';
import Reference from '/home/runner/work/beyond-ui/beyond-ui/docs/reference.md';
import Actionsheet from '/home/runner/work/beyond-ui/beyond-ui/src/actionsheet/README.md';
import Alert from '/home/runner/work/beyond-ui/beyond-ui/src/alert/README.md';
import Banner from '/home/runner/work/beyond-ui/beyond-ui/src/banner/README.md';
import Button from '/home/runner/work/beyond-ui/beyond-ui/src/button/README.md';
import CopyText from '/home/runner/work/beyond-ui/beyond-ui/src/copy-text/README.md';
import Dialog from '/home/runner/work/beyond-ui/beyond-ui/src/dialog/README.md';
import DrawerLayout from '/home/runner/work/beyond-ui/beyond-ui/src/drawer-layout/README.md';
import FormCheckbox from '/home/runner/work/beyond-ui/beyond-ui/src/form-checkbox/README.md';
import FormInput from '/home/runner/work/beyond-ui/beyond-ui/src/form-input/README.md';
import FormRadio from '/home/runner/work/beyond-ui/beyond-ui/src/form-radio/README.md';
import FormRow from '/home/runner/work/beyond-ui/beyond-ui/src/form-row/README.md';
import FormStepNumber from '/home/runner/work/beyond-ui/beyond-ui/src/form-step-number/README.md';
import FormSwitch from '/home/runner/work/beyond-ui/beyond-ui/src/form-switch/README.md';
import FormUploader from '/home/runner/work/beyond-ui/beyond-ui/src/form-uploader/README.md';
import Icon from '/home/runner/work/beyond-ui/beyond-ui/src/icon/README.md';
import Loading from '/home/runner/work/beyond-ui/beyond-ui/src/loading/README.md';
import Notify from '/home/runner/work/beyond-ui/beyond-ui/src/notify/README.md';
import Overlay from '/home/runner/work/beyond-ui/beyond-ui/src/overlay/README.md';
import Popup from '/home/runner/work/beyond-ui/beyond-ui/src/popup/README.md';
import RateList from '/home/runner/work/beyond-ui/beyond-ui/src/rate-list/README.md';
import Segment from '/home/runner/work/beyond-ui/beyond-ui/src/segment/README.md';
import Skeleton from '/home/runner/work/beyond-ui/beyond-ui/src/skeleton/README.md';
import Steps from '/home/runner/work/beyond-ui/beyond-ui/src/steps/README.md';
import TabSegment from '/home/runner/work/beyond-ui/beyond-ui/src/tab-segment/README.md';
import Table from '/home/runner/work/beyond-ui/beyond-ui/src/table/README.md';
import Toast from '/home/runner/work/beyond-ui/beyond-ui/src/toast/README.md';
import Tree from '/home/runner/work/beyond-ui/beyond-ui/src/tree/README.md';

Vue.use(PackageEntry);

export { config };
export const documents = {
  PR,
  Changelog,
  Contribution,
  Deploy,
  Home,
  Quickstart,
  Reference,
  Actionsheet,
  Alert,
  Banner,
  Button,
  CopyText,
  Dialog,
  DrawerLayout,
  FormCheckbox,
  FormInput,
  FormRadio,
  FormRow,
  FormStepNumber,
  FormSwitch,
  FormUploader,
  Icon,
  Loading,
  Notify,
  Overlay,
  Popup,
  RateList,
  Segment,
  Skeleton,
  Steps,
  TabSegment,
  Table,
  Toast,
  Tree
};
export const packageVersion = '1.0.0';
